import React, { useEffect, useState } from "react";
import axios from "axios";



function FetchProducts(){
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = useState(true);
    /*useEffect(() => {
        axios.get("https://dlbackend.dlappstudio.com/api/v1/operations/product/getProducts")
            .then(response => setData(response.data))
            .catch(error => console.log(error));
    }, [])*/

    useEffect(() => {
        setLoading(true);
        fetch("https://dlbackend.dlappstudio.com/api/v1/operations/product/getProducts")
            .then(res => res.json())
            .then(result => {
            // If your backend wraps data in an object like { success: true, products: [] }
            if (result.products) {
                setData(result.products);
            } else {
                setData(result); // If it is already a direct array
            }
            setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
        }, []);

    
    return (
        //<div className="users-container">
            
        <div className="users-container">
            <div className="users-header">
                <div className="users-title">
                <h1>Product Management</h1>
                <p>Manage all products in one place. Control inventory, update details, and monitor sales across your platform.</p>
                </div>
            </div>
            <div className="mt-3">

                {loading && (
                    <div role="status" className="products-loading">Please wait — loading products...</div>
                )}

                <table className="users-table">

                    <thead>
                        <tr>
                            <th>
                                <input type="checkbox" />
                            </th>
                            <th>Product Name</th>
                            <th>Product Description</th>
                            <th>Product Price</th>
                            <th>Product Quantity</th>
                            <th>Product Code</th>
                            {/*<th>Action</th>*/}
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(data) ? data.map((product) => (
                            <tr key={product._id}>
                                <td>
                                    <input type="checkbox" />
                                </td>
                                <td>{product.prodName}</td>
                                <td>{product.prodDesc}</td>
                                <td>{product.prodPrice}</td>
                                <td>{product.prodQuantity}</td>
                                <td>{product.pCode}</td>
                                {/*<td className="actions-cell"> <button className="action-btn edit-btn" title="Edit"> ✏️ </button></td>*/}
                            </tr>
                        )):null}
                    </tbody>
                </table>

            </div>
        </div>
    );
}

export default FetchProducts;